import { UserRestMock } from './bff';

export default {
  user: UserRestMock,
};
